import { render, staticRenderFns } from "./SaleBaseMini.vue?vue&type=template&id=42b3f37d&scoped=true"
import script from "./SaleBaseMini.vue?vue&type=script&lang=js"
export * from "./SaleBaseMini.vue?vue&type=script&lang=js"
import style0 from "./SaleBaseMini.vue?vue&type=style&index=0&id=42b3f37d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b3f37d",
  null
  
)

export default component.exports